import { Identifiable, Task } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { calculateAdvancement } from "../../utils/calculateAdvancement";

function handleRemoveTaskStatus(
  task: Identifiable<Task>,
  { status, nextStatus }: Boundaries["removeTaskStatus"]["success"],
): Identifiable<Task> {
  return calculateAdvancement({
    ...task,
    status: task.status.uuid === status.uuid ? nextStatus : status,
  });
}

export { handleRemoveTaskStatus };
